import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { TASK_SERVICE } from '@eggplant/api-hosts'
import type {
  Error,
  TaskPostBody
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  onError: (error: Error) => void
  onSuccess: () => void
  children?: () => ReactElement
  params: TaskPostBody
}

const CreateTaskRequest = ({
  onError,
  onSuccess,
  children,
  params
}: Props) => {
  const url = `${TASK_SERVICE}/tasks`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='post'
      onError={onError}
      onSuccess={onSuccess}
      params={params}
      url={url}
    />
  )
}

export default CreateTaskRequest
